import React from 'react';
import { ShieldCheck, Lock, Star, Briefcase } from 'lucide-react';

/**
 * Trust signal strip — one component, used at the top of every public
 * SEO page (`/for/*`, `/region/*`, `/pros/*`). Reads zero APIs — values
 * are baked from the current state of the harvest. Update via env-var or
 * the prop overrides when reality shifts.
 *
 * These four signals were chosen because they answer the four cold-visitor
 * objections in one glance:
 *   1. "Are these listings real?"           → 561 verified pros
 *   2. "Do you cover my city?"              → 23 cities (and growing)
 *   3. "Will you nickel-and-dime me?"       → Flat connection fee
 *   4. "Is the payment safe?"               → Stripe-secured
 */
const PublicTrustStrip = ({
  pros = 561,
  cities = 23,
  fee = '£15.52 / ₹1,535 / C$30',
  dataTestId = 'public-trust-strip',
}) => (
  <div
    className="bg-white border-y border-slate-200"
    data-testid={dataTestId}
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 text-center">
        <Badge icon={<Briefcase className="h-3.5 w-3.5" />} label={`${pros}+ verified pros`} />
        <Badge icon={<Star className="h-3.5 w-3.5" />} label={`${cities}+ cities live`} />
        <Badge icon={<ShieldCheck className="h-3.5 w-3.5" />} label={`Flat fee ${fee}`} />
        <Badge icon={<Lock className="h-3.5 w-3.5" />} label="Stripe-secured · 256-bit" />
      </div>
    </div>
  </div>
);

const Badge = ({ icon, label }) => (
  <div className="flex items-center justify-center gap-1.5 text-[10px] sm:text-xs text-slate-600 font-medium">
    <span className="text-[#E07A3A]">{icon}</span>
    <span className="truncate">{label}</span>
  </div>
);

export default PublicTrustStrip;
